import React from 'react';
import Page from '../../../components/surfaces/page';
import COLORS from '../../../constants/colors';
import NavigationHeader from '../../../components/navigation/navigation-header';
import { tKeys } from '../../../translations/keys';
import { useAIAssistLogic } from './logic.web';
import { Box, Flex, Heading, Input, VStack, HStack, Checkbox, TableContainer, Table, Thead, Tbody, Tr, Th, Td, Icon as ChakraIcon, Tag, TagLabel, Text as ChakraText, Spinner, Center, Textarea, IconButton, InputGroup, InputRightElement, Code, Link, Text, ListItem, UnorderedList, OrderedList, Heading as ChakraHeading, Tooltip, SlideFade, Avatar, AvatarBadge, Modal as ChakraUiModal, ModalOverlay as ChakraUiModalOverlay, ModalContent as ChakraUiModalContent, ModalHeader as ChakraUiModalHeader, ModalBody as ChakraUiModalBody, ModalFooter as ChakraUiModalFooter, ModalCloseButton as ChakraUiModalCloseButton, } from '@chakra-ui/react';
import Button from '../../../components/inputs/button';
import { FiFileText, FiSend, FiX, FiRefreshCw, FiMessageSquare, FiUser, FiAlertTriangle, FiTrendingUp, FiClipboard, FiEdit, } from 'react-icons/fi';
import moment from 'moment';
import { Size } from '../../../components/inputs/button/constants/size';
import { Kind } from '../../../components/inputs/button/constants/kind';
import { DocumentPreview } from '../../document-viewer/document-preview/index.web';
import FilterCalendar from '../../../components/pickers/filter-calendar/index.web';
import FilterSelect from '../../home/more/repository/filter-select/index.web';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
export const AIAssist = () => {
    const { t, isModalOpen, selectedDocuments, searchTerm, setSearchTerm, currentMessage, setCurrentMessage, documentPreviewInitialPage, messagesEndRef, inputRef, chatLoading, chatError, chainlitConnected, viewingDocumentId, setViewingDocumentId, setDocumentPreviewInitialPage, detailedDocumentData, isLoadingDetailedDoc, detailedDocError, filterDateFrom, filterDateTo, selectedFilterTypes, documentTypeOptions, isLoadingModalDocs, modalDocsError, documentsForModal, handleSelectDocumentsClick, handleCloseModal, handleConfirmSelection, handleCheckboxChange, handleSelectAllChange, areAllSelected, handleSendMessage, sendPresetQuestion, handleViewFirstSelected, handleCloseViewer, handleSetInstance, handleFilterTypeChange, handleFilterDateFromChange, handleFilterDateToChange, handleResetFilters, displayMessages, isLoading, getTypeColor, enrolmentId, selectedCompanyId, connect, disconnect, handleNewChat, isNewChatModalOpen, handleCloseNewChatModal, handleConfirmNewChat, } = useAIAssistLogic();
    const renderTableContent = () => {
        if (isLoadingModalDocs) {
            return (<Tr>
          <Td colSpan={4}>
            <Center p={5}>
              <Spinner size="lg"/>
            </Center>
          </Td>
        </Tr>);
        }
        if (modalDocsError != null) {
            return (<Tr>
          <Td colSpan={4}>
            <Center p={5}>
              <ChakraText color="red.500">Error loading documents.</ChakraText>
            </Center>
          </Td>
        </Tr>);
        }
        if (documentsForModal.length === 0) {
            return (<Tr>
          <Td colSpan={4}>
            <Center p={5}>
              <ChakraText>No documents found.</ChakraText>
            </Center>
          </Td>
        </Tr>);
        }
        return documentsForModal.map((doc) => {
            const typeColor = getTypeColor(doc.typeName);
            const translatedTypeName = doc.typeName
                ? t(doc.typeName, { defaultValue: doc.typeName })
                : null;
            const isSelected = selectedDocuments.has(doc.id);
            return (<Tr key={doc.id} _hover={{ backgroundColor: 'gray.50' }} backgroundColor={isSelected ? 'blue.50' : 'transparent'}>
          <Td width="5%">
            <Checkbox isChecked={isSelected} onChange={e => handleCheckboxChange(doc.id, e.target.checked)}/>
          </Td>
          <Td width="45%" py={1.5} px={3}>
            <HStack spacing={3} alignItems="center">
              <ChakraIcon as={FiFileText} boxSize={4} color={COLORS.Text.T400.value}/>
              <ChakraText fontSize="14px" fontWeight="normal" noOfLines={1} flexShrink={1} mr={2}>
                {doc.title || 'Untitled Document'}
              </ChakraText>
              {translatedTypeName && (<Tag size="sm" variant="subtle" flexShrink={0} bg={`${typeColor.split('.')[0]}.100`} color={typeColor} borderRadius="full">
                  <TagLabel>{translatedTypeName}</TagLabel>
                </Tag>)}
            </HStack>
          </Td>
          <Td width="25%" py={1.5} px={3}>
            <ChakraText fontSize="sm" color={COLORS.Text.T400.value} noOfLines={1}>
              {doc.eventTitle || '-'}
            </ChakraText>
          </Td>
          <Td width="25%" py={1.5} px={3}>
            <ChakraText fontSize="sm" color={COLORS.Text.T400.value}>
              {doc.issuedOn ? moment(doc.issuedOn).format('L') : '-'}
            </ChakraText>
          </Td>
        </Tr>);
        });
    };
    return (<Page showSideBar backgroundColor={COLORS.BG.value}>
      <NavigationHeader justifyTitle="flex-start" endEnhancer={<HStack spacing={2}>
            {selectedDocuments.size > 0 && (<Tag colorScheme="blue" borderRadius="full" size="md">
                <TagLabel>{selectedDocuments.size} docs selected</TagLabel>
              </Tag>)}
            {/* <Tooltip label="View first selected document" placement="bottom">
              <Button
                onPress={handleViewFirstSelected}
                size={Size.SMALL}
                kind={Kind.OUTLINE}
                isDisabled={selectedDocuments.size === 0}
                startEnhancer={() => <ChakraIcon as={FiFileText} />}
              >
                View Document
              </Button>
            </Tooltip>
            <Tooltip label="Select context documents" placement="bottom">
              <Button
                onPress={handleSelectDocumentsClick}
                size={Size.SMALL}
                startEnhancer={() => <ChakraIcon as={FiPlus} />}
              >
                Select Context Docs
              </Button>
            </Tooltip> */}
            <Tooltip label="Start a new chat" placement="bottom">
              <Button onPress={handleNewChat} size={Size.DEFAULT} kind={Kind.SECONDARY} startEnhancer={() => (<ChakraIcon as={FiEdit} color={COLORS.White.T500.value} mr={2}/>)}>
                New Chat
              </Button>
            </Tooltip>
          </HStack>}>
        <HStack spacing={3} align="center">
          <ChakraText fontWeight="semibold" fontSize="lg">
            {t(tKeys.home.navigation_bar.ai_assist)}
          </ChakraText>
          <HStack spacing={2} align="center">
            <Avatar size="xs" bg={chainlitConnected
            ? COLORS.Success.T500.value
            : COLORS.Warning.T500.value} icon={<FiMessageSquare color={COLORS.White.T500.value} size="0.8em"/>}>
              {chainlitConnected && (<AvatarBadge boxSize="0.9em" bg={COLORS.Success.T500.value} borderColor={COLORS.White.T500.value}/>)}
            </Avatar>
            <ChakraText fontSize="xs" fontWeight="medium" color={chainlitConnected
            ? COLORS.Success.T600.value
            : COLORS.Warning.T600.value}>
              {chainlitConnected ? 'Connected' : 'Connecting...'}
            </ChakraText>
          </HStack>
        </HStack>
      </NavigationHeader>

      <Flex height="calc(100% - 60px)" width="100%" overflow="hidden" justifyContent="center">
        <VStack flex={1} p={4} spacing={4} maxWidth={{ base: '100%', md: '80%', lg: '60%' }} minWidth={{ base: '100%', md: '500px', lg: '700px' }} align="stretch" height="100%" bg={COLORS.White.T500.value} borderRadius="xl" boxShadow="lg" borderWidth="1px" borderColor={COLORS.Govrn.Blue.T100.value}>
          <HStack justify="flex-end" align="center" py={2} px={1}>
            {selectedDocuments.size > 0 && (<Tag size="md" colorScheme="blue" variant="subtle" bg={COLORS.Govrn.Blue.T50.value} color={COLORS.Govrn.Blue.T600.value} borderRadius="full">
                <TagLabel>
                  {selectedDocuments.size} documents in context
                </TagLabel>
              </Tag>)}
          </HStack>

          <Box flex={1} overflowY="auto" borderWidth="0px" p={4} sx={{
            '&::-webkit-scrollbar': {
                width: '6px',
                borderRadius: '8px',
                backgroundColor: COLORS.Govrn.Blue.T50.value,
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: COLORS.Govrn.Blue.T200.value,
                borderRadius: '8px',
                '&:hover': {
                    backgroundColor: COLORS.Govrn.Blue.T300.value,
                },
            },
        }}>
            {!chainlitConnected && !chatLoading && (<Center h="100%">
                <VStack spacing={3}>
                  <Spinner color={COLORS.Govrn.Blue.T500.value}/>
                  <ChakraText color={COLORS.Govrn.Blue.T700.value}>
                    Connecting to chat...
                  </ChakraText>
                </VStack>
              </Center>)}

            {chatError && (<Center h="100%">
                <VStack spacing={3}>
                  <ChakraIcon as={FiRefreshCw} color={COLORS.Error.T500.value} fontSize="2xl"/>
                  <ChakraText color={COLORS.Error.T600.value}>
                    Error connecting to chat.
                  </ChakraText>
                  <Button size={Size.SMALL} kind={Kind.OUTLINE} borderColor={COLORS.Govrn.Blue.T300.value} textColor={COLORS.Govrn.Blue.T500.value} onPress={() => {
                if (enrolmentId && selectedCompanyId) {
                    disconnect();
                    setTimeout(() => {
                        connect({
                            userEnv: {
                                'X-Chainlit-User-Id': enrolmentId,
                                company_id: selectedCompanyId,
                            },
                        });
                    }, 500);
                }
            }}>
                    Retry Connection
                  </Button>
                </VStack>
              </Center>)}

            {chainlitConnected &&
            displayMessages.length === 0 &&
            !chatLoading && (<Center h="100%">
                  <VStack spacing={6} p={6} textAlign="center" maxW="lg">
                    <VStack spacing={3}>
                      <ChakraIcon as={FiMessageSquare} fontSize="5xl" color={COLORS.Govrn.Blue.T500.value}/>
                      <ChakraHeading size="lg" color={COLORS.Govrn.Blue.T700.value}>
                        AI Assistant for Board Directors
                      </ChakraHeading>
                      <ChakraText color={COLORS.Text.T400.value}>
                        Ask me anything about your documents or start with one
                        of these common questions:
                      </ChakraText>
                    </VStack>

                    <HStack spacing={4} alignSelf="stretch" justifyContent="center">
                      {[
                {
                    question: 'What are the key risks and opportunities facing the company in the next 12 months?',
                    icon: FiAlertTriangle,
                },
                {
                    question: 'How is the company performing against its strategic objectives and budget?',
                    icon: FiTrendingUp,
                },
                {
                    question: 'What are the latest updates on major projects or initiatives?',
                    icon: FiClipboard,
                },
            ].map((item, index) => (<Tooltip key={index} label={`Click to ask: "${item.question}"`} placement="bottom" hasArrow bg={COLORS.Govrn.Blue.T700.value} color={COLORS.White.T500.value}>
                          <Box p={5} borderWidth="1px" borderColor={COLORS.Govrn.Blue.T100.value} borderRadius="lg" bg={COLORS.White.T500.value} boxShadow="md" flex={1} cursor="pointer" _hover={{
                    borderColor: COLORS.Govrn.Blue.T400.value,
                    boxShadow: 'lg',
                    transform: 'translateY(-3px)',
                    bg: COLORS.Govrn.Blue.T50.value,
                }} transition="all 0.25s ease-in-out" onClick={() => {
                    if (sendPresetQuestion) {
                        sendPresetQuestion(item.question);
                    }
                    else {
                        console.warn('sendPresetQuestion function is not available from the hook.');
                        setCurrentMessage(item.question);
                        handleSendMessage();
                    }
                    if (inputRef.current)
                        inputRef.current.focus();
                }} role="button" aria-label={`Ask: ${item.question}`}>
                            <VStack spacing={3} textAlign="left" alignItems="center">
                              <ChakraIcon as={item.icon} fontSize="3xl" color={COLORS.Govrn.Blue.T500.value}/>
                              <ChakraText fontSize="sm" fontWeight="medium" color={COLORS.Govrn.Blue.T700.value} textAlign="center">
                                {item.question}
                              </ChakraText>
                            </VStack>
                          </Box>
                        </Tooltip>))}
                    </HStack>
                    <ChakraText fontSize="xs" color={COLORS.Text.T300.value}>
                      You can also type your own question below.
                    </ChakraText>
                  </VStack>
                </Center>)}

            {chainlitConnected && displayMessages.length > 0 && (<VStack align="stretch" spacing={4}>
                {displayMessages.map((msg, index) => {
                const isUser = msg.name === 'user';
                const isLLM = msg.type === 'llm';
                const isTool = msg.type === 'tool';
                const isLastMessage = index === displayMessages.length - 1;
                if (isLLM || isTool) {
                    return (<SlideFade key={msg.id} in={true} offsetY="10px" transition={{
                            enter: { duration: 0.3, delay: index * 0.05 },
                        }}>
                        <HStack spacing={2} justifyContent="flex-start" alignItems="center" bg={COLORS.Govrn.Blue.T50.value} color={COLORS.Govrn.Blue.T700.value} px={3} py={2} borderRadius="md" boxShadow="sm">
                          {isLastMessage && msg.name && (<Spinner size="xs" speed="0.8s" thickness="2px"/>)}
                          <ChakraText fontSize="sm" fontWeight="medium">
                            {msg.name}
                            {isLastMessage && msg.name ? '...' : ''}
                          </ChakraText>
                        </HStack>
                      </SlideFade>);
                }
                return (<SlideFade key={msg.id} in={true} offsetY="10px" transition={{
                        enter: { duration: 0.3, delay: index * 0.05 },
                    }}>
                      <HStack alignItems="flex-start" spacing={3} px={1} justifyContent={isUser ? 'flex-end' : 'flex-start'}>
                        {!isUser && (<Avatar size="sm" bg={COLORS.Govrn.Blue.T500.value} icon={<FiMessageSquare color={COLORS.White.T500.value}/>}/>)}
                        <Box flexShrink={1} maxWidth={{ base: '90%', sm: '80%', md: '75%' }} bg={isUser
                        ? COLORS.Govrn.Blue.T600.value
                        : COLORS.Govrn.Blue.T50.value} color={isUser
                        ? COLORS.White.T500.value
                        : COLORS.Govrn.Blue.T800.value} px={4} py={3} borderRadius="xl" borderTopLeftRadius={isUser ? 'xl' : '0'} borderTopRightRadius={isUser ? '0' : 'xl'} boxShadow="md" position="relative">
                          <ReactMarkdown remarkPlugins={[remarkGfm]} components={{
                        p: ({ node, ...props }) => (<Text mb={2} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        h1: ({ node, ...props }) => (<ChakraHeading as="h1" size="xl" mb={4} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        h2: ({ node, ...props }) => (<ChakraHeading as="h2" size="lg" mb={3} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        h3: ({ node, ...props }) => (<ChakraHeading as="h3" size="md" mb={2} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        h4: ({ node, ...props }) => (<ChakraHeading as="h4" size="sm" mb={1} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        h5: ({ node, ...props }) => (<ChakraHeading as="h5" size="xs" mb={1} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        h6: ({ node, ...props }) => (<ChakraHeading as="h6" size="xs" mb={1} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        ul: ({ node, ...props }) => (<UnorderedList spacing={1} mb={2} ml={4} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        ol: ({ node, ...props }) => (<OrderedList spacing={1} mb={2} ml={4} color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        li: ({ node, ...props }) => (<ListItem color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>),
                        a: ({ node, href, children, ...props }) => {
                            const docLinkPattern = /^([a-fA-F0-9\-]+)\/(\d+)$/;
                            const match = href
                                ? docLinkPattern.exec(href)
                                : null;
                            if (match) {
                                const documentId = match[1];
                                const pageNumber = parseInt(match[2], 10);
                                return (<Link {...props} onClick={e => {
                                        e.preventDefault();
                                        console.log(`Opening document ${documentId} at page ${pageNumber}`);
                                        setViewingDocumentId(documentId);
                                        setDocumentPreviewInitialPage(pageNumber);
                                    }} color={isUser
                                        ? COLORS.White.T500.value
                                        : COLORS.Govrn.Blue.T500.value} textDecoration="underline" cursor="pointer">
                                      {children}
                                    </Link>);
                            }
                            return (<Link color={isUser
                                    ? COLORS.White.T500.value
                                    : COLORS.Govrn.Blue.T500.value} textDecoration="underline" isExternal href={href} {...props}>
                                    {children}
                                  </Link>);
                        },
                        code: props => {
                            const { node, inline, className, children, ...rest } = props;
                            const match = /language-(\w+)/.exec(className || '');
                            return !inline && match ? (<Box as="pre" p={3} my={2} bg={isUser
                                    ? COLORS.Govrn.Blue.T700.value
                                    : COLORS.Govrn.Blue.T100.value} borderRadius="md" overflowX="auto">
                                    <Code className={className} color={isUser
                                    ? COLORS.White.T500.value
                                    : COLORS.Govrn.Blue.T800.value} {...rest}>
                                      {String(children).replace(/\n$/, '')}
                                    </Code>
                                  </Box>) : (<Code colorScheme={isUser ? 'whiteAlpha' : 'blue'} bg={isUser
                                    ? 'rgba(255,255,255,0.1)'
                                    : COLORS.Govrn.Blue.T100.value} px={1} borderRadius="md" fontSize="0.9em" {...rest}>
                                    {children}
                                  </Code>);
                        },
                        blockquote: ({ node, ...props }) => (<Box as="blockquote" borderLeftWidth="4px" borderColor={isUser
                                ? COLORS.Govrn.Blue.T300.value
                                : COLORS.Govrn.Blue.T300.value} pl={4} py={2} my={2} fontStyle="italic" color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T700.value} bg={isUser
                                ? 'transparent'
                                : COLORS.Govrn.Blue.T100.value} {...props}/>),
                        table: ({ node, ...props }) => (<TableContainer my={4}>
                                  <Table variant="simple" size="sm" color={isUser
                                ? COLORS.White.T500.value
                                : COLORS.Govrn.Blue.T800.value} {...props}/>
                                </TableContainer>),
                        thead: ({ node, ...props }) => (<Thead {...props}/>),
                        tbody: ({ node, ...props }) => (<Tbody {...props}/>),
                        tr: ({ node, ...props }) => <Tr {...props}/>,
                        th: ({ node, ...props }) => (<Th borderColor={isUser
                                ? COLORS.Govrn.Blue.T400.value
                                : COLORS.Govrn.Blue.T200.value} {...props}/>),
                        td: ({ node, ...props }) => (<Td borderColor={isUser
                                ? COLORS.Govrn.Blue.T400.value
                                : COLORS.Govrn.Blue.T200.value} {...props}/>),
                    }}>
                            {msg.output}
                          </ReactMarkdown>

                          <ChakraText fontSize="xs" color={isUser
                        ? COLORS.Govrn.Blue.T200.value
                        : COLORS.Text.T400.value} mt={2} textAlign="right">
                            {msg.createdAt
                        ? new Date(msg.createdAt).toLocaleTimeString([], {
                            hour: '2-digit',
                            minute: '2-digit',
                        })
                        : ''}
                            {msg.streaming && (<Spinner size="xs" ml={2} color={isUser
                            ? COLORS.White.T500.value
                            : COLORS.Govrn.Blue.T500.value}/>)}
                          </ChakraText>
                        </Box>
                        {isUser && (<Avatar size="sm" bg={COLORS.Govrn.Blue.T600.value} icon={<FiUser color={COLORS.White.T500.value}/>}/>)}
                      </HStack>
                    </SlideFade>);
            })}
                <div ref={messagesEndRef}/>
              </VStack>)}

            {chatLoading && !displayMessages.length && (<Center h="100%">
                <VStack spacing={3}>
                  <Spinner size="xl" thickness="4px" speed="0.7s" color={COLORS.Govrn.Blue.T500.value}/>
                  <ChakraText color={COLORS.Govrn.Blue.T700.value}>
                    Initializing chat...
                  </ChakraText>
                </VStack>
              </Center>)}
          </Box>

          <HStack spacing={3} align="flex-end" py={2} px={1}>
            <Box position="relative" flex={1}>
              <Textarea ref={inputRef} value={currentMessage} onChange={e => setCurrentMessage(e.target.value)} placeholder="Ask GOVRN AI..." onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
            }
        }} minH="50px" maxH="150px" resize="none" isDisabled={!chainlitConnected || chatLoading} borderRadius="lg" focusBorderColor={COLORS.Govrn.Blue.T500.value} variant="outline" bg={COLORS.White.T500.value} borderColor={COLORS.Govrn.Blue.T200.value} _hover={{
            borderColor: COLORS.Govrn.Blue.T300.value,
        }} _focus={{
            bg: COLORS.White.T500.value,
            borderColor: COLORS.Govrn.Blue.T500.value,
            boxShadow: `0 0 0 1px ${COLORS.Govrn.Blue.T500.value}`,
        }} px={4} py={3} transition="all 0.2s"/>
              {currentMessage && (<IconButton aria-label="Clear message" icon={<ChakraIcon as={FiX} color={COLORS.Govrn.Blue.T500.value}/>} size="xs" variant="ghost" position="absolute" top="8px" right="8px" onClick={() => setCurrentMessage('')} _hover={{ bg: COLORS.Govrn.Blue.T100.value }}/>)}
            </Box>
            <Tooltip label={!chainlitConnected
            ? 'Waiting for connection'
            : currentMessage.trim() === ''
                ? 'Type a message'
                : 'Send message'} placement="top" hasArrow bg={COLORS.Govrn.Blue.T700.value} color={COLORS.White.T500.value}>
              <IconButton aria-label="Send message" icon={<ChakraIcon as={FiSend}/>} onClick={handleSendMessage} isDisabled={currentMessage.trim() === '' ||
            !chainlitConnected ||
            chatLoading} bg={COLORS.Govrn.Blue.T500.value} color={COLORS.White.T500.value} borderRadius="lg" size="lg" px={6} _hover={{
            bg: COLORS.Govrn.Blue.T600.value,
            transform: 'scale(1.03)',
        }} _active={{
            bg: COLORS.Govrn.Blue.T700.value,
        }} transition="all 0.2s ease-in-out"/>
            </Tooltip>
          </HStack>
        </VStack>

        {viewingDocumentId && (<VStack width={'40%'} height="100%" align="stretch" borderLeft="1px solid" borderColor="gray.200" position="relative">
            <HStack justifyContent="space-between" alignItems="center" p={3} borderBottom="1px solid" borderColor="gray.200" flexShrink={0}>
              <Heading size="sm" noOfLines={1}>
                {detailedDocumentData?.title ?? 'Loading document...'}
              </Heading>
              <IconButton aria-label="Close document viewer" icon={<ChakraIcon as={FiX}/>} size="sm" onClick={handleCloseViewer} variant="ghost"/>
            </HStack>

            <Box flex={1} overflow="hidden" p={isLoadingDetailedDoc || detailedDocError != null ? 4 : 0}>
              {isLoadingDetailedDoc ? (<Center h="100%">
                  <Spinner size="xl"/>
                </Center>) : detailedDocError != null ? (<Center h="100%">
                  <ChakraText color="red.500">
                    Error loading document details.
                  </ChakraText>
                </Center>) : detailedDocumentData &&
                detailedDocumentData.file?.uri &&
                detailedDocumentData.title ? (<DocumentPreview selectedDocument={{
                    documentUri: detailedDocumentData.file.uri,
                    documentTitle: detailedDocumentData.title,
                    document: detailedDocumentData,
                }} setPDFtronInstance={handleSetInstance} initialPage={documentPreviewInitialPage ?? undefined}/>) : (<Center h="100%">
                  <ChakraText color="orange.500">
                    Document details loaded, but cannot be previewed (missing
                    URI or Title).
                  </ChakraText>
                </Center>)}
            </Box>
          </VStack>)}
      </Flex>

      <ChakraUiModal isOpen={isModalOpen} onClose={handleCloseModal} size="6xl" isCentered motionPreset="scale">
        <ChakraUiModalOverlay />
        <ChakraUiModalContent>
          <ChakraUiModalHeader>Select Documents</ChakraUiModalHeader>
          <ChakraUiModalCloseButton />
          <ChakraUiModalBody>
            <VStack align="stretch" spacing={4} p={0}>
              <Input placeholder="Search by name, type, event..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)}/>

              <HStack p={4} bg={COLORS.BG.value} spacing={4} wrap="wrap" alignItems="center" borderTopWidth={1} borderBottomWidth={1} borderColor={COLORS.Govrn.Blue.T100.value}>
                <FilterSelect options={documentTypeOptions} placeholder="Filter by Type..." onChange={handleFilterTypeChange} isMulti={true} value={selectedFilterTypes}/>
                <InputGroup size="md" flexShrink={0}>
                  <FilterCalendar name="dateFrom" value={filterDateFrom} onChange={handleFilterDateFromChange} title="From:"/>
                  {filterDateFrom && (<InputRightElement>
                      <IconButton aria-label="Clear From date" icon={<ChakraIcon as={FiX} boxSize={3}/>} size="xs" variant="ghost" onClick={() => handleFilterDateFromChange(null)}/>
                    </InputRightElement>)}
                </InputGroup>
                <InputGroup size="md" flexShrink={0}>
                  <FilterCalendar name="dateTo" value={filterDateTo} onChange={handleFilterDateToChange} title="To:" minDate={filterDateFrom?.toISOString()}/>
                  {filterDateTo && (<InputRightElement>
                      <IconButton aria-label="Clear To date" icon={<ChakraIcon as={FiX} boxSize={3}/>} size="xs" variant="ghost" onClick={() => handleFilterDateToChange(null)}/>
                    </InputRightElement>)}
                </InputGroup>
                <Button size={Size.SMALL} kind={Kind.TERTIARY} textColor={COLORS.Govrn.Blue.T500.value} onPress={handleResetFilters} isDisabled={!filterDateFrom &&
            !filterDateTo &&
            selectedFilterTypes.length === 0}>
                  Reset Filters
                </Button>
              </HStack>

              <TableContainer border="1px solid" borderColor={COLORS.Govrn.Blue.T100.value} borderRadius="md" maxHeight="400px" overflowY="auto">
                <Table variant="simple" size="sm">
                  <Thead position="sticky" top={0} bg={COLORS.Govrn.Blue.T50.value} zIndex={1}>
                    <Tr>
                      <Th width="5%" borderColor={COLORS.Govrn.Blue.T200.value}>
                        <Checkbox colorScheme="blue" isChecked={areAllSelected} onChange={e => handleSelectAllChange(e.target.checked)} isDisabled={documentsForModal.length === 0 || isLoadingModalDocs}/>
                      </Th>
                      <Th width="45%" borderColor={COLORS.Govrn.Blue.T200.value} color={COLORS.Govrn.Blue.T700.value}>
                        File Info
                      </Th>
                      <Th width="25%" borderColor={COLORS.Govrn.Blue.T200.value} color={COLORS.Govrn.Blue.T700.value}>
                        Event Name
                      </Th>
                      <Th width="25%" borderColor={COLORS.Govrn.Blue.T200.value} color={COLORS.Govrn.Blue.T700.value}>
                        Issued On
                      </Th>
                    </Tr>
                  </Thead>
                  <Tbody>{renderTableContent()}</Tbody>
                </Table>
              </TableContainer>
            </VStack>
          </ChakraUiModalBody>
          <ChakraUiModalFooter borderTopWidth="1px" borderColor={COLORS.Govrn.Blue.T100.value}>
            <HStack justify="flex-end" spacing={3}>
              <Button onPress={handleCloseModal} kind={Kind.OUTLINE} borderColor={COLORS.Govrn.Blue.T300.value} textColor={COLORS.Govrn.Blue.T500.value}>
                Cancel
              </Button>
              <Button onPress={handleConfirmSelection} isDisabled={selectedDocuments.size === 0} backgroundColorPerso={COLORS.Govrn.Blue.T500.value} textColor={COLORS.White.T500.value}>
                Confirm Selection ({selectedDocuments.size})
              </Button>
            </HStack>
          </ChakraUiModalFooter>
        </ChakraUiModalContent>
      </ChakraUiModal>

      {/* New Chat Confirmation Modal */}
      <ChakraUiModal isOpen={isNewChatModalOpen} onClose={handleCloseNewChatModal} isCentered motionPreset="slideInBottom">
        <ChakraUiModalOverlay />
        <ChakraUiModalContent>
          <ChakraUiModalHeader>Start New Chat?</ChakraUiModalHeader>
          <ChakraUiModalCloseButton />
          <ChakraUiModalBody>
            <ChakraText>
              Are you sure you want to start a new chat? This will clear all
              current messages.
            </ChakraText>
          </ChakraUiModalBody>
          <ChakraUiModalFooter>
            <Box mr={3}>
              <Button kind={Kind.OUTLINE} onPress={handleCloseNewChatModal}>
                Cancel
              </Button>
            </Box>
            <Button backgroundColorPerso={COLORS.Error.T500.value} textColor={COLORS.White.T500.value} onPress={handleConfirmNewChat}>
              Confirm New Chat
            </Button>
          </ChakraUiModalFooter>
        </ChakraUiModalContent>
      </ChakraUiModal>
    </Page>);
};
